//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Btn from './Btn.vue';

export default {
	name: 'FilterBar',

	components: { Btn: Btn },

	data: function data() {
		return {
			isOpen: false,
			isTop: false
		};
	},


	props: {
		show: {
			type: Boolean,
			default: false
		},

		items: {
			type: Array,
			required: true
		}
	},

	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		tags: function tags() {
			var label = this.$lang('filterAll', null, this.lang);
			return [{ title: label }].concat(this.items);
		},
		tag: function tag() {
			return this.$route.query.tag;
		},
		filter: function filter() {
			return this.$route.query.filter || '';
		},
		page: function page() {
			return this.$route.query.page;
		},
		basePath: function basePath() {
			var lang = '';
			switch (this.$route.params.lang) {
				case 'en':
					lang = 'eng/';
					break;
			}
			var str = '/' + lang + this.$route.params.page + '/' + '?';

			if (this.tag) str = str + '&tag=' + this.tag;
			//if (this.page) str = str + '&page=' + this.page

			return str.replace('&', '');
		},
		current: function current() {
			var _this = this;

			return this.tags.filter(function (item) {
				return ~_this.filter.indexOf(item.tag);
			})[0] || this.tags[0];
		}
	},

	methods: {
		setPath: function setPath(tag) {
			var _this2 = this;

			if (!tag) {
				if (!this.filter) return '';

				var filter = this.filter.split(',').filter(function (el) {
					return el !== _this2.current.tag;
				}).join(',');

				return filter ? '&filter=' + filter : '';
			}

			if (!this.filter) return '&filter=' + tag;

			if (this.current.tag) return '&filter=' + this.filter.replace(this.current.tag, tag);else return '&filter=' + this.filter + ',' + tag;
		},
		toggle: function toggle() {
			if (this.show) {
				var bounds = this.$refs.navBody.getBoundingClientRect(),
				    bottomPos = bounds.bottom <= document.documentElement.clientHeight,
				    topPos = bounds.top >= bounds.height;

				this.isTop = !bottomPos && topPos;
				this.isOpen = true;
			} else {
				this.isTop = false;
				this.isOpen = false;
			}
		}
	},

	watch: {
		show: function show(val) {
			this.toggle();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FilterNav.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FilterNav.vue
// module chunks = 0